import React from "react";
import { View, Text, Platform } from "react-native";
import { useNavigation, useRoute } from "@react-navigation/native";
import tw from "twrnc";

import { AppBackButton } from "./Buttons";
import SupportButton from "../support/SupportButton";
import { useIsMobileUX } from "@/components/hooks/useIsMobileUX";
import { useFrame } from "@/components/layout/FrameContext";

export const onBackPressed = (navigation, route) => {
  switch (route.name) {
    case "EventEdit":
    case "CreateEvent":
    case "Profile":
      navigation.popToTop();
      break;
    case "GuestList":
    case "GuestAdd":
    case "GuestImport":
      if (navigation.canGoBack()) {
        navigation.goBack();
      } else {
        navigation.navigate("EventEdit", route.params);
      }
      break;
    case "GuestBook":
      navigation.navigate("EventEdit", route.params);
      break;
    case "UpdateEmail":
    case "VideoWall":
    case "WhatsNew":
    case "ForgotPassword":
    case "PasswordReset":
    case "ForgotPasswordLinkSent":
      // If signed in, then go to Profile
      if (navigation.canGoBack()) {
        navigation.goBack();
      } else {
        navigation.navigate("Profile");
      }
      break;
    default:
      navigation.navigate("EventList");
  }
};

const AppHeader = ({
  title,
  hasLeftButton = true,
  leftButtonComponent,
  renderRightButton,
  // The support chat button shows on every screen with this header in the apps and on
  // the web app's mobile layout; desktop web uses the floating launcher instead.
  hasSupportButton,
  style,
}) => {
  const isMobileUX = useIsMobileUX();
  // Next to the event menu (wide layouts) the menu has the chat button, and a
  // screen opened from the menu needs no back button.
  const frame = useFrame();
  const inPane = frame?.kind === "pane";
  const showSupportButton =
    hasSupportButton ?? (!inPane && (Platform.OS !== "web" || isMobileUX));
  const showLeftButton = hasLeftButton && (!inPane || frame.showBack);
  const navigation = useNavigation();
  const route = useRoute();

  const renderLeftButton = () => {
    return (
      leftButtonComponent ?? (
        <AppBackButton onPress={() => onBackPressed(navigation, route)} />
      )
    );
  };

  return (
    <View
      style={[
        tw`flex-row items-center justify-between px-4 py-3`,
        inPane && tw`min-h-[54px]`,
        style,
      ]}
    >
      <View style={tw`flex-1`}>{showLeftButton && renderLeftButton()}</View>
      {!!title && (
        <View style={tw`flex-1 items-center`}>
          <Text
            style={tw`text-[21px] font-extrabold text-black text-center ${
              Platform.OS === "web" ? "tracking-normal leading-normal" : ""
            }`}
          >
            {title}
          </Text>
        </View>
      )}
      <View style={tw`flex-1 flex-row items-center justify-end`}>
        {!!renderRightButton && renderRightButton()}
        {showSupportButton && <SupportButton style={tw`ml-3`} />}
      </View>
    </View>
  );
};

export default AppHeader;
